module.exports = __webpack_public_path__ + "static/hutijin-2adaaee7d89d0274baf613b3edddfe8e.png";